import {NgModule} from '@angular/core';
import {OccupationalProfileMovieComponent} from "./occupational-profile-movie.component";
import {CommonModule} from "@angular/common";
import { YoutubeIFrameApiService } from './youtube-iframe-api.service';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        YoutubeIFrameApiService
    ],
    declarations: [
        OccupationalProfileMovieComponent
    ],
    exports: [
        OccupationalProfileMovieComponent
    ]
})

export class MovieModule {

}
